import { api } from './api';
import { fetchResource, updateResource } from './fetchResource';

export function fetchSavingsModule() {
  return dispatch => fetchResource(dispatch, 'modules/savings', 'SAVINGS_MODULE_FETCHED');
}

export const editSavingsModule = (field, value) => ({ type: 'EDIT_SAVINGS_MODULE', field, value });

export function updateSavingsModule(payload) {
  return dispatch => updateResource(dispatch, 'modules/savings', payload, 'SAVINGS_MODULE_FETCHED');
}
